import { styled, Typography, lighten, Grid2 as Grid, alpha } from "@mui/material";
import React from "react";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { ActivityModel } from "../../models/EmailActionModels";
import { formatActivityDate } from "../../utils/formatDate";
import { Avatar } from "../../components/Avatar";
import { Comment } from "../../components/Comment/Comment";
import { COMMENT_HIGHLIGHT_CLASS } from "./const";

type Props = {
  activity: ActivityModel;
  leading?: boolean;
};

const StyledGrid = styled(Grid)(({ theme }) => {
  const isDarkMode = theme.palette.mode === "dark";

  return {
    backgroundColor: isDarkMode ? "#1E1E1E" : "#F5F5F5",
    padding: "8px",

    [`&.${COMMENT_HIGHLIGHT_CLASS}`]: {
      backgroundColor: isDarkMode ? alpha(theme.palette.primary.main, 0.3) : lighten(theme.palette.primary.main, 0.8),
    },
  };
});

export function ActivityRender({ activity, leading }: Props) {
  const { currentUser } = useCurrentUser();
  const isMine = activity.createdBy?.id === currentUser?.id;

  const renderName = () => {
    if (!activity.createdBy) return null;

    if (activity.createdBy.id === currentUser?.id) {
      return "You";
    } else {
      return activity.createdBy.fullName;
    }
  };

  const renderDate = () => {
    return formatActivityDate(activity.createdAt);
  };

  return (
    <Grid container={true} flexWrap="nowrap" mt={leading ? 1 : 0.25} flexDirection={isMine ? "row-reverse" : "row"}>
      {activity.createdBy && (
        <Grid mt={leading ? 2.5 : 0} mr={isMine ? 0 : 1} ml={isMine ? 1 : 0} width={24} height={24} flex="0 0 auto">
          {leading && <Avatar name={activity.createdBy.fullName} />}
        </Grid>
      )}
      <Grid display="flex" flexDirection="column" alignItems={isMine ? "flex-end" : "flex-start"}>
        {leading && (
          <Grid container={true} flexWrap="nowrap" spacing={1} flexDirection={isMine ? "row-reverse" : "row"}>
            <Typography
              component="span"
              color="textSecondary"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              fontSize={12}
            >
              {renderName()}
            </Typography>
            <Typography component="span" color="textSecondary" whiteSpace="nowrap" fontSize={12}>
              {renderDate()}
            </Typography>
          </Grid>
        )}
        <StyledGrid
          id={activity.id}
          borderRadius={1}
          width="fit-content"
          className={isMine ? COMMENT_HIGHLIGHT_CLASS : ""}
        >
          <Comment content={activity.content} />
        </StyledGrid>
      </Grid>
    </Grid>
  );
}
